import React, { useState, useEffect, FC, ReactNode } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AdminLayoutProps } from "../types/components";
import DashboardLayout from "./layout/DashboardLayout";
import { useAdmin } from "../context/AdminContext";
// removed profile completion modal logic

const AdminLayout: FC<AdminLayoutProps> = ({ children }) => {
  const { pendingCompaniesCount } = useAdmin();
  const navigate = useNavigate();
  const location = useLocation();
  // removed: showProfileModal state

  useEffect(() => {
    // console.log('DashboardWrapper - User:', user);
    // console.log('DashboardWrapper - User role:', user?.role);
    // console.log('DashboardWrapper - User ID:', user?.userId);
    // removed: modal checks and redirects
  }, [pendingCompaniesCount, location.pathname, navigate]);

  // removed: custom event listener for profile modal

  // removed: modal handlers

  return (
    <DashboardLayout
      agentDetails={{
        pendingCompaniesCount: pendingCompaniesCount,
      }}
    >
      {children}
    </DashboardLayout>
  );
};

export default AdminLayout;
